const getSpecifications = (variants) => {
  return variants.reduce((specifications, variant) => {
    Object.keys(variant.specification).forEach((specificationKey) => {
      const specificationLabel = variant.specification[specificationKey].label;
      const specificationValue = variant.specification[specificationKey].value;
      const foundSpecificationIndex = specifications.findIndex((item) => item.label === specificationLabel);

      if (foundSpecificationIndex >= 0) {
        const includesSpecificationValue = specifications[foundSpecificationIndex].values.includes(specificationValue);

        if (!includesSpecificationValue) {
          specifications[foundSpecificationIndex].values.push(specificationValue);
        }
      } else {
        specifications.push({
          label: specificationLabel,
          values: [specificationValue],
        });
      }
    });

    return specifications;
  }, []);
};

const specificationContainsMatchesCriterion = (specification, criterion) => {
  let matchesCriteria = false;

  Object.keys(specification).forEach((specificationKey) => {
    if (
      !matchesCriteria &&
      specification[specificationKey].label === criterion.label &&
      specification[specificationKey].value === criterion.value
    ) {
      matchesCriteria = true;
    }
  });

  return matchesCriteria;
};

const getNumberOfMatchingCriteria = (specification, criteria) => {
  return criteria.reduce((matchingCriteriaCount, criterion) => {
    if (specificationContainsMatchesCriterion(specification, criterion)) {
      return matchingCriteriaCount + 1;
    }

    return matchingCriteriaCount;
  }, 0);
};

const getSelectedVariant = (variants, criteria) => {
  return variants
    .map((variant) => ({
      ...variant,
      matchingCriteriaCount: getNumberOfMatchingCriteria(variant.specification, criteria),
    }))
    .sort((a, b) => a.matchingCriteriaCount - b.matchingCriteriaCount)
    .pop();
};

const getUpdatedCriteria = (state, action) => {
  const filteredCriteria = state.activeItem.selectedCriteria.filter((criterion) => {
    return criterion.label !== action.criteria.label;
  });

  return [...filteredCriteria, action.criteria];
};

const hasSelectedAllCriteria = (selectedVariant, criteria) =>
  Object.keys(selectedVariant.specification).length === criteria.length;

export const requestAccessory = (state) => ({
  ...state,
  activeItem: {
    isLoading: true,
  },
});

export const receiveAccessory = (state, action) => {
  const {
    name,
    title,
    longDescriptionTitle,
    longDescriptionBody,
    price,
    variants,
    images,
    category,
    isCustomisable,
    customiseAccessoryUrl,
  } = action.accessory;

  const { bundleSize } = variants[0].quantities;
  let productUnavailable = true;
  const availableVariants = [];
  variants.forEach((variant) => {
    productUnavailable = productUnavailable && !variant.availability.isAvailable;
    if (variant.availability.isAvailable) {
      availableVariants.push(variant);
    }
  });
  const { availability } = variants[0];

  return {
    ...state,
    activeItem: {
      ...state.activeItem,
      isLoading: false,
      name,
      title,
      longDescriptionTitle,
      longDescriptionBody,
      price,
      variants: availableVariants,
      images,
      specification: getSpecifications(availableVariants),
      quantity: bundleSize,
      bundleSize,
      selectedVariant: null,
      selectedCriteria: [],
      canAddToCart: false,
      category,
      productUnavailable,
      availability,
      isCustomisable,
      customiseAccessoryUrl,
    },
  };
};

export const requestAccessoryPrice = (state) => ({
  ...state,
  activeItem: {
    ...state.activeItem,
    price: {
      ...state.activeItem.price,
      isLoading: true,
    },
  },
});

export const receiveAccessoryPrice = (state, action) => {
  return {
    ...state,
    activeItem: {
      ...state.activeItem,
      price: {
        ...action.price,
        isLoading: false,
      },
    },
  };
};

export const accessoryVariantChange = (state, action) => {
  const updatedCriteria = getUpdatedCriteria(state, action);
  const selectedVariant = getSelectedVariant(state.activeItem.variants, updatedCriteria);

  if (selectedVariant) {
    const outOfStock = selectedVariant.quantities.stock < state.activeItem.bundleSize;
    const selectedAllCriteria = hasSelectedAllCriteria(selectedVariant, updatedCriteria);

    return {
      ...state,
      activeItem: {
        ...state.activeItem,
        images: action.criteria.singleOptionCriterion ? state.activeItem.images : selectedVariant.images,
        selectedVariant: {
          name: selectedVariant.name,
        },
        stock: selectedVariant.quantities.stock,
        outOfStock,
        selectedAllCriteria,
        selectedCriteria: updatedCriteria,
        canAddToCart: selectedAllCriteria && !outOfStock,
        isCustomisable: selectedVariant.isCustomisable,
      },
    };
  }

  return state;
};
